/**
 * YouTube URL から動画IDを抽出する
 * 対応フォーマット:
 * - https://www.youtube.com/watch?v=VIDEO_ID
 * - https://youtu.be/VIDEO_ID
 * - https://www.youtube.com/embed/VIDEO_ID
 * - https://youtube.com/watch?v=VIDEO_ID
 */
export const extractYouTubeVideoId = (url: string): string | null => {
	try {
		const urlObj = new URL(url);
		const hostname = urlObj.hostname.toLowerCase();

		// youtube.com または www.youtube.com
		if (hostname === "youtube.com" || hostname === "www.youtube.com") {
			// /watch?v=VIDEO_ID 形式
			const videoId = urlObj.searchParams.get("v");
			if (videoId) return videoId;

			// /embed/VIDEO_ID 形式
			const embedMatch = urlObj.pathname.match(/^\/embed\/([a-zA-Z0-9_-]+)/);
			if (embedMatch) return embedMatch[1];

			return null;
		}

		// youtu.be/VIDEO_ID 形式
		if (hostname === "youtu.be") {
			const videoId = urlObj.pathname.slice(1);
			if (videoId && /^[a-zA-Z0-9_-]+$/.test(videoId)) {
				return videoId;
			}
			return null;
		}

		return null;
	} catch {
		return null;
	}
};
